(function () {
    'use strict';
    angular.module('app')
        .controller('courseDetailModalController', courseDetailModalController);

    function courseDetailModalController(modalService,$uibModalInstance, $q, $scope, enumService,
        trainingInnerService, courseItem, settingModel, $location, $anchorScroll, commonService, defaultTabIndex) {

        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.setPathUrl = setPathUrl;
        vm.goTop = goTop;
        vm.cancel = cancel;
        vm.enroll = enroll;
        vm.tabChange = tabChange;
        vm.sessionChoice = sessionChoice;
        vm.enum = {
            courseType: enumService.courseType
        };
        //===Main==
        init();
        //=========
        function init() {
            dataInit();
            logicInit();
            $scope.$on('emitExamSubmit', function () {
                enroll();
            });
        }

        function dataInit() {
            settingModel = settingModel || {};
            vm.data = {
                importCourse: courseItem || null, //.....理論上是清單列傳入的班次課程
                importCourseActivities: null,//..........傳入的班次課程包含學習動作(WS14)
                sessionItem: null,//.....................班次資料
                sessionDetail: null,//...................班次詳細資料
                courageItem: null,//.....................學程資料
                courageDetail: null,//...................學程詳細資料
                enrollQuestionItem: null,//..............報名前問卷
                enrollActivity: null,//..................報名問卷
                tabIndex: 0,//...........................畫面頁籤
            };
            vm.view = {
                enrollQuestionMode: settingModel.isEnroll || false,
                hasEnrollQuestion: false,//..............有報名前問卷
                contentCourage: false,
                contentCourse: false,
                pageLoad: false,
                couragePage: false,//.............學程頁面
                sessionPage: false,//.............班次頁面
            };
        }
        function logicInit() {
            return sessionInit(vm.data.importCourse)
                .then(function () {
                    var selectActive = trainingInnerService.getSelectActive(vm.data.importCourse);
                    return selectActive.then(function (data) {
                        //console.log("selectActiveResult:", data);
                        vm.data.importCourseActivities = data;
                    });
                })
                .then(function () {
                    vm.view.hasEnrollQuestion = (vm.data.importCourseActivities.preSurveyItemId > 0);
                    //console.log('hasQues:',vm.view.hasEnrollQuestion );
                    if (vm.view.hasEnrollQuestion) {
                        vm.data.enrollActivity = {
                            type: '問卷',
                            itemId: vm.data.importCourseActivities.preSurveyItemId,
                        };
                    }
                    vm.data.tabIndex = vm.view.enrollQuestionMode ? 2 : vm.data.tabIndex;
                    Accordion();

                });
        }

        function sessionInit(importItem) {
            if (!importItem) { return; }
            var courseDetail = trainingInnerService.getCourseDetail(importItem);
            return courseDetail.then(function (data) {
                var courseDetailResult = detailFormat(data);
                switch (parseInt(importItem.courseType)) {
                    case vm.enum.courseType.courage:
                        //學程
                        vm.data.courageItem = angular.copy(importItem);
                        vm.data.courageDetail = courseDetailResult;
                        vm.view.couragePage = true;
                        vm.data.tabIndex = defaultTabIndex ? defaultTabIndex : 0; // 第一頁籤是 0，但客戶要求預設顯示第2頁籤
                        break;
                    default:
                        //非學程
                        vm.data.sessionItem = angular.copy(importItem);
                        vm.data.sessionDetail = courseDetailResult;
                        vm.view.sessionPage = true;
                        vm.data.tabIndex = defaultTabIndex ? defaultTabIndex : 1; // 第一頁籤是 1，但客戶要求預設顯示第2頁籤
                        break;
                }
            });
        }


        function detailFormat(sourceData) {
            var detailData = angular.copy(sourceData);
            if (!detailData) { return detailData; }
            //===========
            var brCheck = /(\r?\n)/g;
            _.forEach(detailData, function (value, key) {
                var isInt = (value === parseInt(value, 10));
                var isString = (typeof value === "string");
                if (isInt) {
                    var isAsNull = (value < 0);

                    if (isAsNull) {
                        detailData[key] = null;
                    }
                    else {
                        detailData[key] = value + '';
                    }
                }
                else if (isString) {
                    detailData[key] = value.replace(brCheck, "<br/>");
                }
            });
            //===========
            if (detailData.reference) {
                //檢查參考文件格式
                if (!angular.isArray(detailData.reference)) {
                    //參考文件必須是陣列
                    detailData.reference = null;
                }
                if (detailData.reference.length <= 0) {
                    //參考文件必須有內容
                    detailData.reference = null;
                }
            }
            return detailData;
        }
        function goTop() {
            $location.hash('PageTop');
            $anchorScroll();
            $location.hash('');
        }
        function enroll() {
            trainingInnerService.postSessionAction(vm.data.importCourse, 'Enroll')
                .then(function (result) {
                    if (!result) {
                        $uibModalInstance.dismiss('cancel');
                        return;
                    }
                    $uibModalInstance.close(result);
                });
        }
        function tabChange(index) {
            vm.view.couragePage = false;
            vm.view.sessionPage = false;
            switch (index) {
                case 0:
                    vm.view.couragePage = true;
                    vm.data.sessionItem = null;
                    vm.data.sessionDetail = null;
                    vm.data.tabIndex = 0;
                    break;
                case 1:
                    vm.view.sessionPage = true;
                    vm.data.tabIndex = 1;
                    break;
                case 2:
                    vm.data.tabIndex = 2;
                    break;
                default: break;
            }
            // console.log("enter tabChange , index:", vm.data.tabIndex);
        }

        function sessionChoice(sessionItem) {
            // console.log("enter sessionChoice,sessionItem:", sessionItem);
            if (!sessionItem.courseType) {
                sessionItem.courseType = 1;
            }
            return sessionInit(sessionItem).then(function () {
                tabChange(1);
            });
        }
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function setPathUrl(filePath) {
            var pathUrl = commonService.ctmsFilePath(filePath);
            return pathUrl;
        }
        //======Jquery====
        function Accordion() {
            $(document).off("click", ".accordion .title");

            $(document).on("click", ".accordion .title", function (j) {
                var dropDown = $(this).closest('.col-sm-12').find('p.acc-info');
                $(this).closest('.accordion').find('p.acc-info').not(dropDown).slideUp();

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).closest('.accordion').find('a.active').removeClass('active');
                    $(this).addClass('active');
                }

                dropDown.stop(false, true).slideToggle();

                j.preventDefault();
            });
        }


    }
})();